<template>
  <div class="wx-payment">
    <div class="title">微信支付</div>
    <div class="content">
      <!-- 订单详情 -->
      <PaymentInfo :orderData="orderData" />
      <div class="line"></div>
      <div class="imgs">
        <div class="bar-code">
          <div class="box">
            <div v-show="!isMask" id="qrCode" ref="qrCode"></div>
            <div v-show="isMask" class="mack-img">
              <img src="../../assets/image/order/erweima.png" alt="" />
              <span @click="refresh">
                <i class="iconfont icon-icon-shuaxin"></i>
                <span>点击刷新</span>
              </span>
            </div>
          </div>
          <p>请打开手机微信</p>
          <p>扫一扫完成支付</p>
        </div>
        <div class="example">
          <img src="@/assets/image/boot-page/wx.png" alt="" />
        </div>
      </div>
    </div>
    <div>
      
    </div>
  </div>
</template>

<script>
import paymentMixins from '@/mixins/payment'
export default {
  mixins: [paymentMixins],
  data() {
    return {
      type: 2,
    }
  }
}
</script>

<style src="./style/payment.scss" lang="scss" scoped></style>
